import Vue from 'vue'
import Vuex from 'vuex'
import Api from '@/services/api.service';
import AuthService from '@/services/auth.service';
import jwt_decode from "jwt-decode";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    snackbar: {
      visible: false,
      text: null,
      timeout: 5000,
      multiline: false,
      color: 'primary'
    },
    status: '',
    token: localStorage.getItem('token') || '',
    user : {},
  },
  mutations: {
    showSnackbar(state, payload) {
      state.snackbar.text = payload.text
      state.snackbar.multiline = (payload.text.length > 50) ? true : false
      
      if (payload.multiline) {
        state.snackbar.multiline = payload.multiline
      }
      
      if (payload.timeout) {
        state.snackbar.timeout = payload.timeout
      }

      if (payload.color) {
        state.snackbar.color = payload.color
      }

      state.snackbar.visible = true
    },
    closeSnackbar(state) {
      state.snackbar.visible = false
      state.snackbar.multiline = false
      state.snackbar.timeout = 5000
      state.snackbar.text = null
      state.snackbar.color = 'primary'
    },
    auth_request(state){
      state.status = 'loading'
    },
    auth_success(state, data){
      state.status = 'success'
      state.token = data.token
      state.user = data.user
    },
    auth_error(state){
      state.status = 'error'
      state.token = ''
      state.user = {}
    },
    logout(state){
      state.status = ''
      state.token = ''
      state.user = {}
    },
  },
  actions: {
    login({commit}, user){
      return new Promise((resolve, reject) => {
        commit('auth_request')
        AuthService.login(user)
          .then(resp => {
            const data = jwt_decode(resp.data.access_token);
            const token = resp.data.access_token
            const user = {
              id: data.id,
              name: data.name,
              roles: data.roles,
              permissions: data.permissions,
            }
            localStorage.setItem('token', token)
            Api.defaults.headers.common['Authorization'] = `Bearer ${token}`
            commit('auth_success', { token:token, user: user} )
            resolve(resp)
          })
          .catch(err => {
            commit('auth_error')
            localStorage.removeItem('token')
            reject(err)
          })
      })
    },
    logout({commit}){
      return new Promise((resolve, reject) => {
        AuthService.logout()
          .then((resp) => {
            localStorage.removeItem('token')
            delete Api.defaults.headers.common['Authorization']
            commit('logout')
            resolve(resp)
          })
          .catch(err => {
            commit('auth_error')
            localStorage.removeItem('token')
            reject(err)
          })
      })
    },
    expire_session({commit}) {
      return new Promise((resolve, reject) => {
        AuthService.logout()
          .then((resp) => {
            localStorage.removeItem('token')
            delete Api.defaults.headers.common['Authorization']
            commit('logout')
            commit('showSnackbar', { text: "Sessão expirada, faça login novamente!", color:"warning" });
            resolve(resp)
          })
          .catch(err => {
            commit('auth_error')
            commit('showSnackbar', { text: "Sessão expirada, faça login novamente!", color:"warning" });
            localStorage.removeItem('token')
            reject(err)
          })
      })
    },
  },
  modules: {
  },
  getters : {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    user: state => state.user,
    permissions: state => state.user.permissions ?? [],
    token: state => state.token,
  },
  plugins: [
    createPersistedState()
  ],
})
